import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { TOPIC_CLUSTERS_DASHBOARD_LINK, TopicTypes } from '../data/topicEditor/constants';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ClusterDropdown = ({
  options,
  value,
  canCreateCluster,
  onOpenCreateTopicDialog,
  onClusterChange
}) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.label"
    }),
    "data-test-id": "topic-editor-cluster-dropdown",
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "cluster-select",
      minimumSearchCount: 0,
      options: options,
      onChange: onClusterChange,
      value: value,
      dropdownFooter: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.maxClusterToolTip"
            }),
            disabled: canCreateCluster,
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "link",
              disabled: !canCreateCluster,
              onClick: () => {
                onOpenCreateTopicDialog(TopicTypes.CLUSTER);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.createCluster"
              })
            })
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-y-2",
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            external: true,
            href: TOPIC_CLUSTERS_DASHBOARD_LINK,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.editClusters"
            })
          })
        })]
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.placeholder"
      }),
      searchable: true
    })
  });
};